import { render, staticRenderFns } from "./cardprofile.vue?vue&type=template&id=677fecaa&"
import script from "./cardprofile.vue?vue&type=script&lang=js&"
export * from "./cardprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports